import i18n from "@/i18n/index";

const catalogs = {
    // Used for saving the current catalogs for left sidebar.
    items: [],
    // The selected catalog data, used to be displayed in the grid.
    selectedCatalogData: [],
    // The current columns of the selected grid.
    columns: [],
    columnsForData: [],
    // The data of the currently selected catalog.
    selectedCat: {},
    // Unsaved changes done to the catalogs that have not yet been sent to backend
    unsavedChanges: [],
    // used for comparation when entering edit on a catalog.
    temporaryColumnsCache: null,
    dataFromImport: [],
    // In edit Catalog columns
    inEditCatalogColumns: [],
    // In edit catalog
    copyCatalogList: [],
    currApp: null,
    catalogsAlreadySaved: false,
    fromCatList: false,
    deleteCatAction: false,
    fromImportExcel: false,
    commitId: null,
    masterId: null,
    dataModelList: [],
    newCatalog: false
};

catalogs.columnDataTypesWithAttach = [
    {
        label: i18n.t("catalogs.baseTypes").toUpperCase(),
        value: "bt",
        itemDisabled: true,
        className: "bg-grey-color f-pl-md"
    },
    { label: "String", value: "String", className: "f-pl-lg list-items-popover" },
    { label: "Date", value: "Date", className: "f-pl-lg list-items-popover" },
    { label: "Time", value: "Time", className: "f-pl-lg list-items-popover" },
    { label: "DateTime", value: "DateTime", className: "f-pl-lg list-items-popover" },
    { label: "Integer", value: "Integer", className: "f-pl-lg list-items-popover" },
    { label: "Boolean", value: "Boolean", className: "f-pl-lg list-items-popover" },
    { label: "Decimal", value: "Decimal", className: "f-pl-lg list-items-popover" },
    { label: "Attachment", value: "Attachment", className: "f-pl-lg list-items-popover" },
    { label: "RichText", value: "RichText", className: "f-pl-lg list-items-popover" }
];

catalogs.columnDataTypes = [
    {
        label: "Base Types",
        value: "bt",
        itemDisabled: true,
        icon: "label_important"
    },
    { label: "String", value: "String" },
    { label: "Date", value: "Date" },
    { label: "Time", value: "Time" },
    { label: "DateTime", value: "DateTime" },
    { label: "Integer", value: "Integer" },
    { label: "Boolean", value: "Boolean" },
    { label: "Decimal", value: "Decimal" }
];

export default catalogs;
